import React, { useEffect, useRef } from 'react';

// ─── TODO: Replace with your actual AdSense values ───────────────────────────
// Publisher ID: found in AdSense → Account → Account information
// Format: ca-pub-XXXXXXXXXXXXXXXX
const ADSENSE_PUBLISHER_ID = 'ca-pub-1574057994717099';

// Ad Unit ID: found in AdSense → Ads → By ad unit → [your ad unit] → data-ad-slot
// This is the number-only slot ID, e.g. "1234567890"
const ADSENSE_SLOT_ID = '7592264144';
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Google AdSense banner for web.
 * Shows a responsive display ad to free users.
 * Renders nothing on native platforms (handled by AdMob instead).
 */
const WebAdBanner = ({ isPro }) => {
    const adRef = useRef(null);
    const pushed = useRef(false);

    useEffect(() => {
        // Don't show ads to Pro users
        if (isPro) return;
        // Only push once per mount
        if (pushed.current) return;
        pushed.current = true;

        try {
            if (window.adsbygoogle) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (e) {
            // AdSense not loaded yet (e.g. ad blocker), silently ignore
        }
    }, [isPro]);

    // Don't render for Pro users
    if (isPro) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 64, // sits above the bottom nav bar (64px tall)
                left: 0,
                right: 0,
                zIndex: 900,
                background: 'var(--bg-secondary)',
                borderTop: '1px solid var(--border-color)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60px',
                overflow: 'hidden',
            }}
        >
            <ins
                ref={adRef}
                className="adsbygoogle"
                style={{ display: 'block', width: '100%', minHeight: '50px' }}
                data-ad-client={ADSENSE_PUBLISHER_ID}
                data-ad-slot={ADSENSE_SLOT_ID}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
};

export default WebAdBanner;
